import { Typography } from "@mui/material";
import React from "react";

const PageTitle = ({ children, sx: sxProp = {}, ...props }) => {
  return (
    <Typography
      sx={{
        fontSize: { xs: "18px", sm: "20px", md: "22px" },
        fontWeight: 500,
        ...sxProp,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
};

export default PageTitle;
